"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _activitySetting = require("@/api/operationManagement/activitySetting");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  components: {},
  data: function data() {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '长期有效',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            end.setTime(start.getTime() + 3600 * 1000 * 24 * 3600);
            start.setHours(0, 0, 0, 0); // 设置为00:00:00
            end.setHours(23, 59, 59, 999); // 设置为23:59:59
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      id: '',
      ruleForm: {
        radio: 0,
        num: '',
        money: '',
        time: null
      },
      rules: {
        num: [{
          required: true,
          message: '请输入内容',
          trigger: 'blur'
        }],
        money: [{
          required: true,
          message: '请输入内容',
          trigger: 'blur'
        }],
        time: [{
          required: true,
          message: '请选择时间',
          trigger: 'change'
        }]
      }
    };
  },
  created: function created() {
    this.getts();
  },
  methods: {
    getts: function getts() {
      var _this = this;
      (0, _activitySetting.getSetting)({}).then(function (res) {
        _this.ruleForm.radio = res.data.enable;
        if (res.data.startTime && res.data.endTime) {
          _this.ruleForm.time = [res.data.startTime, res.data.endTime];
        } else {
          var end = new Date();
          var start = new Date();
          end.setTime(start.getTime() + 3600 * 1000 * 24 * 3600);
          start.setHours(0, 0, 0, 0); // 设置为00:00:00
          end.setHours(23, 59, 59, 999); // 设置为23:59:59
          _this.ruleForm.time = [_this.formatDate(start), _this.formatDate(end)];
        }
        _this.ruleForm.money = res.data.subsidyAmt;
        _this.ruleForm.num = res.data.subsidyNum;
        _this.appId = res.data.appId;
        _this.id = res.data.id;
      });
    },
    formatDate: function formatDate(d) {
      var date = new Date(d);
      var YY = date.getFullYear() + '-';
      var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
      var ss = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      return YY + MM + DD + ' ' + hh + mm + ss;
    },
    times: function times() {},
    submitForm: function submitForm(formName) {
      var _this2 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          (0, _activitySetting.saveSetting)({
            enable: _this2.ruleForm.radio,
            startTime: _this2.ruleForm.time[0],
            endTime: _this2.ruleForm.time[1],
            subsidyAmt: _this2.ruleForm.money,
            subsidyNum: _this2.ruleForm.num,
            id: _this2.id
          }).then(function (res) {
            if (res.data) {
              _this2.$notify.success({
                title: '温馨提示',
                message: '操作成功'
              });
              _this2.getts();
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};